export default "__VITE_ASSET__702f3533__"